import { PRODUCT_TYPE } from '@ahmdigital/constants';

export const CUSTOMER_PRODUCT_TYPES = [
  PRODUCT_TYPE.COMBINED,
  PRODUCT_TYPE.EXTRAS,
  PRODUCT_TYPE.HOSPITAL,
  PRODUCT_TYPE.PACKAGE,
] as const;

export type CustomerProductType = (typeof CUSTOMER_PRODUCT_TYPES)[number];

export type Dependant = {
  dob: string;
  firstName: string;
  fullTimeStudent: boolean;
  gender: string;
  lastName: string;
  relationship: string;
  title: string;
};

export type CustomerMember = {
  continuous?: boolean;
  dob?: string;
  email?: string;
  relationship: string;
  [key: string]: unknown;
};

export type CustomerState = {
  dependants: Dependant[];
  frequency: string;
  hasRefinedPrice: boolean;
  hasSetBasicDetails: boolean;
  hospitalExcess: string;
  income?: number | null;
  incomeTier: string;
  incomeType: string;
  lastViewedProduct?: string | null;
  lhc: number;
  members: CustomerMember[];
  paymentMethod: string;
  productType?: CustomerProductType;
  rebate: boolean;
  scale: string;
  state: string | undefined;
  stateChanged: boolean;
  switching: string | boolean;
  youthDiscountPercentage: number;
};
